import { render, staticRenderFns } from "./JdsIcon.vue?vue&type=template&id=d22f5038"
import script from "./JdsIcon.vue?vue&type=script&lang=js"
export * from "./JdsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports